import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentDeliveryMaterials from '../EntregaMateriais/ContentDeliveryMaterials/DigitalMaterials';

const DeliveryDigitalMaterials = () => {
  return (
    <>
      <HeaderApp />
      <ContentDeliveryMaterials />
      <Bottom />
    </>
  );
};

export default DeliveryDigitalMaterials;
